/** Unwrap nested user object from API responses or corrupted storage */
export const normalizeUser = (data) => {
  if (!data || typeof data !== 'object') return null;
  if (data.user && typeof data.user === 'object' && !data.email && !data.username) {
    return data.user;
  }
  return data;
};
